export enum WaybillMergeType {
  FOUR_PER_A4_PAGE = 'application/A4+pdf;multi',
  ONE_PER_A6_PAGE = 'application/A6+pdf;single',
  ONE_PER_A4_PAGE = 'application/A4+pdf;single'
}
